import { omit } from 'lodash-es'

import { ADMIN_API_METHOD_TYPES, type AdminEnv } from '@lib/sdk/api/modules/admin/types.admin'
import { usePostRobot } from '@lib/sdk/utils/postrobot'
/**
 * Fetches the necessary info for the app to know where it is embedded.
 *
 * Check out [usePitcherApi().getEnv()](../internal/functions/createHighLevelApi.md#getenv) for more information.
 *
 * @example
 * adminApi.getEnv()
 */
export async function getEnv(): Promise<AdminEnv> {
  const pr = await usePostRobot()
  const response = await pr.send(window.parent, ADMIN_API_METHOD_TYPES.GET_ENV)
  const env = <AdminEnv>response.data
  return omit(env, 'pitcher.org_config.segment')
}
